import { reportError } from '@lib/errorHandler'

export function isTwitter(url: string): boolean {
  return url.includes('twitter.com') || url.includes('x.com')
}

export function isLinkedIn(url: string): boolean {
  return url.includes('linkedin.com')
}

export function isInstagram(url: string): boolean {
  return url.includes('instagram.com')
}

export function convertToXEmbedUrl(url: string): string | null {
  try {
    let tweetId
    const match = url.match(/(?:twitter\.com|x\.com)\/\w+\/status\/(\d+)/)
    if (match) {
      tweetId = match[1]
    }
    if (!tweetId) return null
    return `https://platform.twitter.com/embed/Tweet.html?id=${tweetId}`
  } catch (error) {
    reportError(error, 'convertToXEmbedUrl', 'social_embed')
    return null
  }
}

export function convertToLinkedInEmbedUrl(url: string): string | null {
  try {
    let activityId
    let shareId

    // Handle posts with activity IDs
    if (url.includes('/posts/')) {
      const match = url.match(/activity-(\d+)/)
      if (match) {
        activityId = match[1]
      }
    }

    // Handle direct activity URNs
    if (url.includes('urn:li:activity:')) {
      const match = url.match(/urn:li:activity:(\d+)/)
      if (match) {
        activityId = match[1]
      }
    }

    // Handle share URNs (new format)
    if (url.includes('urn:li:share:')) {
      const match = url.match(/urn:li:share:(\d+)/)
      if (match) {
        shareId = match[1]
      }
    }

    // Return the appropriate embed URL
    if (activityId) {
      return `https://www.linkedin.com/embed/feed/update/urn:li:activity:${activityId}`
    } else if (shareId) {
      return `https://www.linkedin.com/embed/feed/update/urn:li:share:${shareId}`
    }

    return null
  } catch (error) {
    reportError(error, 'convertToLinkedInEmbedUrl', 'social_embed')
    return null
  }
}

export function convertToInstagramEmbedUrl(url: string): string | null {
  try {
    let match
    if (url.includes('instagram.com/p/')) {
      match = url.match(/instagram\.com\/p\/([^/?]+)/)
    } else if (url.includes('instagram.com/reel/')) {
      match = url.match(/instagram\.com\/reel\/([^/?]+)/)
    }
    if (!match) return null
    const postId = match[1]
    return `https://www.instagram.com/p/${postId}/embed`
  } catch (error) {
    reportError(error, 'convertToInstagramEmbedUrl', 'social_embed')
    return null
  }
}

export function getEmbedUrl(url: string): string | null {
  if (isTwitter(url)) {
    return convertToXEmbedUrl(url)
  } else if (isLinkedIn(url)) {
    return convertToLinkedInEmbedUrl(url)
  } else if (isInstagram(url)) {
    return convertToInstagramEmbedUrl(url)
  }
  return null
}
